export default __webpack_public_path__ + "static/media/looplogo.70a29e1e.svg";